// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateEstimateStagesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CreateEstimateStagesQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Region', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Market', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Community', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Subdivision', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Lot', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Structure', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
    | { __typename?: 'Unit', id: string, stages: Array<{ __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
   };

export type CreateEstimateMutationVariables = Types.Exact<{
  input: Types.SaveEstimateInput;
}>;


export type CreateEstimateMutation = { __typename?: 'Mutation', saveEstimate: { __typename?: 'SaveEstimateResult', estimate: { __typename?: 'Estimate', id: string, changeEvent?: { __typename?: 'ChangeEvent', id: string, estimates: Array<{ __typename?: 'Estimate', id: string }>, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } } | null | undefined, projectStage: { __typename?: 'ProjectStage', id: string, canEditProjectItemsDirectly: boolean } } } };


export const CreateEstimateStagesDocument = gql`
    query CreateEstimateStages($projectId: ID!) {
  project(id: $projectId) {
    id
    stages {
      id
      canCreateFinalEstimate
      stage {
        code
        name
      }
    }
  }
}
    `;

/**
 * __useCreateEstimateStagesQuery__
 *
 * To run a query within a React component, call `useCreateEstimateStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateEstimateStagesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateEstimateStagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables> & ({ variables: CreateEstimateStagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>(CreateEstimateStagesDocument, options);
      }
export function useCreateEstimateStagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>(CreateEstimateStagesDocument, options);
        }
// @ts-ignore
export function useCreateEstimateStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>;
export function useCreateEstimateStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateEstimateStagesQuery | undefined, CreateEstimateStagesQueryVariables>;
export function useCreateEstimateStagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>(CreateEstimateStagesDocument, options);
        }
export type CreateEstimateStagesQueryHookResult = ReturnType<typeof useCreateEstimateStagesQuery>;
export type CreateEstimateStagesLazyQueryHookResult = ReturnType<typeof useCreateEstimateStagesLazyQuery>;
export type CreateEstimateStagesSuspenseQueryHookResult = ReturnType<typeof useCreateEstimateStagesSuspenseQuery>;
export type CreateEstimateStagesQueryResult = Apollo.QueryResult<CreateEstimateStagesQuery, CreateEstimateStagesQueryVariables>;
export const CreateEstimateDocument = gql`
    mutation CreateEstimate($input: SaveEstimateInput!) {
  saveEstimate(input: $input) {
    estimate {
      id
      changeEvent {
        id
        estimates {
          id
        }
        canEditLineItems {
          allowed
        }
      }
      projectStage {
        id
        canEditProjectItemsDirectly
      }
    }
  }
}
    `;
export type CreateEstimateMutationFn = Apollo.MutationFunction<CreateEstimateMutation, CreateEstimateMutationVariables>;

/**
 * __useCreateEstimateMutation__
 *
 * To run a mutation, you first call `useCreateEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateMutation, { data, loading, error }] = useCreateEstimateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEstimateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEstimateMutation, CreateEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEstimateMutation, CreateEstimateMutationVariables>(CreateEstimateDocument, options);
      }
export type CreateEstimateMutationHookResult = ReturnType<typeof useCreateEstimateMutation>;
export type CreateEstimateMutationResult = Apollo.MutationResult<CreateEstimateMutation>;
export type CreateEstimateMutationOptions = Apollo.BaseMutationOptions<CreateEstimateMutation, CreateEstimateMutationVariables>;